/* capkov-rd-swatch: oříznutí swatchů na kartě produktu (+N). Dřív se celý tento kód vypisoval inline v KAŽDÉ kartě (~5 kB × desítky karet);
   teď je jednou tady (defer) a karta jen zavolá registraci. Inicializace registerAllVisible() projde všechny karty přítomné při načtení. */
(function () {
    // Install once (very important on collection pages).
    if (window.__SWATCH_CLAMP_INSTALLED__) {
      // Per-card lightweight registration (if helper exists).
      if (typeof window.__swatchClampRegister === "function") {
        var currentCard = document.currentScript && document.currentScript.closest("product-card");
        if (currentCard) window.__swatchClampRegister(currentCard);
      }
      return;
    }
    window.__SWATCH_CLAMP_INSTALLED__ = true;

    var processedRoots = new WeakSet();
    var observedFieldsets = new WeakSet();

    /* QA 6. 10.: vybraná (nejprodávanější) barva musí zůstat vidět – když by ji ořez schoval pod „+N“, přesune se na začátek řady (input + label drží pohromadě) */
    function pullSelected(fs) {
      if (!fs || fs.dataset.rdSel === "1") return;
      fs.dataset.rdSel = "1";
      var inp = fs.querySelector("input:checked");
      if (!inp) return;
      var lab = inp.nextElementSibling && inp.nextElementSibling.tagName === "LABEL" ? inp.nextElementSibling : (inp.id ? fs.querySelector('label[for="' + inp.id + '"]') : null);
      var unit = [inp]; if (lab) unit.push(lab);
      var first = fs.firstElementChild;
      if (first && first.tagName === "LEGEND") first = first.nextElementSibling;
      if (!first || first === inp || first === lab) return;
      for (var i = 0; i < unit.length; i++) fs.insertBefore(unit[i], first);
    }

    function getChildren(fs) {
      return Array.prototype.slice.call(fs.children).filter(function (el) {
        if (el.tagName && el.tagName.toLowerCase() === "legend") return false;
        if (el.classList && el.classList.contains("product-card__view-more-swatch")) return false;
        return true;
      });
    }

    function reset(children, more) {
      for (var i = 0; i < children.length; i++) children[i].style.display = "";
      more.style.display = "none";
      more.textContent = "+0";
    }

    function isOverflowing(fs) {
      // epsilon avoids 1px rounding noise
      return (fs.scrollWidth - fs.clientWidth) > 1;
    }

    function clampFieldset(fs) {
      if (!fs || fs.dataset.__clamping === "1") return;

      var more = fs.querySelector(".product-card__view-more-swatch");
      if (!more) return;

      // Avoid clamping when not laid out yet
      if (fs.clientWidth <= 0) return;

      fs.dataset.__clamping = "1";

      pullSelected(fs);
      var children = getChildren(fs);
      reset(children, more);

      if (!isOverflowing(fs)) {
        fs.dataset.__clamping = "0";
        return;
      }

      // Overflow => show "+N" and hide from END until it fits WITH "+N"
      var hidden = 0;
      more.style.display = "inline-flex";
      more.textContent = "+1";

      for (var i = children.length - 1; i >= 0; i--) {
        if (!isOverflowing(fs)) break;
        children[i].style.display = "none";
        hidden++;
        more.textContent = "+" + hidden;
      }

      if (hidden <= 0) {
        more.style.display = "none";
        more.textContent = "+0";
      }

      fs.dataset.__clamping = "0";
    }

    // Perf (4. 10.): dávkové ořezání – čtení a zápisy se nestřídají (jedno přepočtení rozložení na fázi místo desítek na kartu).
    // Výsledek je stejný jako u clampFieldset (skryje swatche od konce, dokud se řada s „+N“ nevejde).
    function clampBatch(list) {
      var items = [], i, j, fs, more, ch;
      for (i = 0; i < list.length; i++) {
        fs = list[i]; if (!fs || fs.dataset.__clamping === "1") continue;
        more = fs.querySelector(".product-card__view-more-swatch"); if (!more) continue;
        pullSelected(fs); items.push({ fs: fs, more: more, ch: getChildren(fs) });
      }
      if (!items.length) return;
      for (i = 0; i < items.length; i++) { fs = items[i]; for (j = 0; j < fs.ch.length; j++) fs.ch[j].style.display = ""; fs.more.style.display = "none"; fs.more.textContent = "+0"; }
      for (i = 0; i < items.length; i++) { fs = items[i]; fs.w = fs.fs.clientWidth; fs.over = fs.w > 0 && isOverflowing(fs.fs); }
      var over = items.filter(function (x) { return x.over; });
      over.forEach(function (x) { x.more.style.display = "inline-flex"; x.more.textContent = "+1"; });
      over.forEach(function (x) {
        x.more.textContent = "+" + x.ch.length; /* nejširší možné „+N“ (dřív se měřilo „+1“ → „+9“ přetékalo o ~9 px) */
        x.mw = x.more.offsetWidth;
        x.pr = parseFloat(getComputedStyle(x.fs).paddingRight) || 0;
        x.gap = parseFloat(getComputedStyle(x.fs).columnGap) || 0;
        x.right = x.ch.map(function (c) { return c.getBoundingClientRect().right; });
        x.lim = x.fs.getBoundingClientRect().right - (x.fs.clientWidth ? (x.fs.getBoundingClientRect().width - x.fs.clientWidth) / 2 : 0) - x.pr;
        x.base = x.ch.length ? x.ch[0].offsetLeft : 0;
      });
      over.forEach(function (x) {
        var keep = 0;
        for (var k = 0; k < x.ch.length; k++) { if (x.right[k] + x.gap + x.mw <= x.lim) keep = k + 1; else break; }
        var hidden = x.ch.length - keep; if (hidden < 1) hidden = 1;
        for (var m = x.ch.length - hidden; m < x.ch.length; m++) x.ch[m].style.display = "none";
        x.more.textContent = "+" + hidden; x.hid = hidden;
      });
      /* kontrola skutečností (okraje swatchů mají margin, ne gap): dokud se řada s „+N“ nevejde, skryje se o jeden víc (max. 6 průchodů, jen pro karty, které přetékají) */
      for (var pass = 0; pass < 6; pass++) {
        var still = over.filter(function (x) { return x.hid < x.ch.length && (x.fs.scrollWidth - x.fs.clientWidth) > 1; });
        if (!still.length) break;
        still.forEach(function (x) { x.hid++; x.ch[x.ch.length - x.hid].style.display = "none"; x.more.textContent = "+" + x.hid; });
      }
    }

    function clampRoot(root) {
      if (!root) return;
      var sets = root.querySelectorAll('fieldset[data-swatch-clamp="auto"]');
      for (var i = 0; i < sets.length; i++) {
        clampFieldset(sets[i]);
      }
    }

    // ---------- Observers (fast + incremental) ----------
    // Perf (3. 10.): karty mimo obrazovku se neměří hned po načtení (to dělalo dlouhý úkol na kolekcích s desítkami karet);
    // fieldset se změří až při prvním zobrazení a teprve potom se začne hlídat ResizeObserverem.
    var io = null;
    if ("IntersectionObserver" in window) {
      io = new IntersectionObserver(function (entries) {
        var vis = [];
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            var t = entries[i].target;
            vis.push(t);
            io.unobserve(t);
          }
        }
        if (vis.length) {
          clampBatch(vis);
          if (ro) for (var j = 0; j < vis.length; j++) { vis[j].__rdW = Math.round(vis[j].clientWidth); ro.observe(vis[j]); }
        }
      }, { root: null, rootMargin: "200px", threshold: 0.01 });
    }

    var ro = null;
    if ("ResizeObserver" in window) {
      ro = new ResizeObserver(function (entries) {
        // Only reclamp the resized fieldset(s), not the whole page
        var l = [];
        for (var i = 0; i < entries.length; i++) { var t = entries[i].target, w = Math.round(entries[i].contentRect.width); if (t.__rdW === w) continue; t.__rdW = w; l.push(t); } /* 4. 10.: první hlášení po observe() a změny jen výšky se nepřeměřují */
        if (l.length) clampBatch(l);
      });
    }

    function observeFieldset(fs) {
      if (!fs || observedFieldsets.has(fs)) return;
      observedFieldsets.add(fs);

      if (io) io.observe(fs);
      else if (ro) ro.observe(fs);
    }

    function registerRoot(root) {
      if (!root || processedRoots.has(root)) return;
      processedRoots.add(root);

      var sets = root.querySelectorAll('fieldset[data-swatch-clamp="auto"]');
      for (var i = 0; i < sets.length; i++) observeFieldset(sets[i]);

      // Bez IntersectionObserveru (starší prohlížeč) zůstává původní počáteční měření, odložené mimo první vykreslení
      if (!io) {
        if ("requestIdleCallback" in window) {
          requestIdleCallback(function () { clampRoot(root); }, { timeout: 300 });
        } else {
          requestAnimationFrame(function () { clampRoot(root); });
        }
      }
    }

    // 4. 10.: karty vložené až po načtení (výsledky hledání se dotahují fetchem a inline skript v kartě se nespustí) se zaregistrují sledováním DOM
    if ("MutationObserver" in window) {
      var pend = [], mraf = 0;
      new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) { var n = ms[i].addedNodes[j]; if (n.nodeType === 1) pend.push(n); }
        if (pend.length && !mraf) mraf = requestAnimationFrame(function () {
          mraf = 0; var l = pend; pend = [];
          for (var k = 0; k < l.length; k++) {
            var n = l[k];
            if (n.tagName === "PRODUCT-CARD") registerRoot(n);
            else if (n.querySelectorAll) { var cs = n.querySelectorAll("product-card"); for (var q = 0; q < cs.length; q++) registerRoot(cs[q]); }
          }
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }

    // Expose lightweight per-card registration for subsequent inline calls
    window.__swatchClampRegister = registerRoot;

    // ---------- Initial run ----------
    function registerAllVisible() {
      var cards = document.querySelectorAll("product-card");
      for (var i = 0; i < cards.length; i++) registerRoot(cards[i]);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", registerAllVisible, { once: true });
    } else {
      registerAllVisible();
    }

    // Shopify theme editor / section reload safety (scope to section target)
    document.addEventListener("shopify:section:load", function (e) {
      if (e && e.target) registerRoot(e.target);
    });
    document.addEventListener("shopify:section:select", function (e) {
      if (e && e.target) registerRoot(e.target);
    });

    // Window resize fallback (only if ResizeObserver not supported)
    if (!ro) {
      var t = null;
      window.addEventListener("resize", function () {
        window.clearTimeout(t);
        t = window.setTimeout(function () {
          registerAllVisible();
        }, 160);
      });
    }

    // Per-card immediate registration when this script appears inside product-card
    var currentCard = document.currentScript && document.currentScript.closest("product-card");
    if (currentCard) registerRoot(currentCard);
  })();
